import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { ID_ESTADO_EN_ESPERA, ID_ESTADO_PENDIENTE_PAGO } from '../../constants/pedidoEstados'
import { PasarelaMP } from '../reutilizables/pasarelaPagos/PasarelaMP'
import styles from './Compras.module.css'

const PAGO_EN_CTA_CTE = 3
const AUMENTO_TIENDA_OFICIAL = 1

const Comprobante = ({ vendedor, pedido, muestraPasarela }) => {
  const items = {
    items: vendedor.pedidoItems.map((item) => ({
      title: item.titulo,
      quantity: item.cantidad,
      unit_price: item.precioUnitario * (1 + item.alicuota / 100) * ((item.anticipo || 100) / 100),
      fee_percentage: item.esTiendaOficial
        ? (item.porcentajeExposicion + AUMENTO_TIENDA_OFICIAL) / 100
        : item.porcentajeExposicion / 100
    })),
    orderId: pedido.idPedido,
    metadata: { pedidoItems: pedido.pedidoItems.map((item) => item.idPedidoItem) },
    email: vendedor.email,
    idVendedor: vendedor.idVendedor
  }

  return (
    <div className={styles.container}>
      <div className={styles.center}>
        <h3 className={styles.title}>Esta operación finalizó y tu pedido ha sido confirmado</h3>

        <p>
          Click aquí para ir al
          <Link className={styles.link} to="/Pedidos">
            Pedido #{pedido.idPedido}
          </Link>
        </p>

        {/* ESTADO DEL PEDIDO */}
        <div className={styles.section}>
          <p className={styles.subtitle}>Estado del pedido</p>
          <span className={styles.status}>
            {pedido.pedidoItems[0]?.idPagoEstado === PAGO_EN_CTA_CTE
              ? 'Cuenta corriente'
              : 'Pendiente de pago'}
          </span>
        </div>

        {/* DATOS DEL VENDEDOR */}
        <div className={styles.section}>
          <h4>Vendedor</h4>
          <p className={styles.info}>{vendedor.razonSocial}</p>
          <p className={styles.info}>Email: {vendedor.email}</p>
          {vendedor.telefono && <p className={styles.info}>Tel: {vendedor.telefono}</p>}
          {vendedor.celular && <p className={styles.info}>Cel: {vendedor.celular}</p>}
          <p className={styles.info}>
            Domicilio:
            {vendedor.altura ? `${vendedor.calle} ${vendedor.altura}` : vendedor.calle}
          </p>
        </div>

        {/* MERCADO PAGO */}
        {muestraPasarela &&
          (pedido.pedidoItems[0]?.idPedidoItemEstado === ID_ESTADO_EN_ESPERA ||
            pedido.pedidoItems[0]?.idPedidoItemEstado === ID_ESTADO_PENDIENTE_PAGO) && (
            <div className={styles.section}>
              <h4>Pagar ahora</h4>
              <div className={styles.mpBox}>
                <PasarelaMP items={items} />
              </div>
            </div>
          )}
      </div>
    </div>
  )
}

export default Comprobante

Comprobante.propTypes = {
  vendedor: PropTypes.shape({
    razonSocial: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    telefono: PropTypes.string,
    celular: PropTypes.string,
    calle: PropTypes.string.isRequired,
    altura: PropTypes.string,
    pedidoItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    idVendedor: PropTypes.number.isRequired
  }).isRequired,
  pedido: PropTypes.shape({
    idPedido: PropTypes.number.isRequired,
    pedidoItems: PropTypes.arrayOf(
      PropTypes.shape({
        idPagoEstado: PropTypes.number.isRequired,
        idPedidoItemEstado: PropTypes.number.isRequired,
        esTiendaOficial: PropTypes.bool.isRequired
      })
    ).isRequired
  }).isRequired,
  muestraPasarela: PropTypes.bool.isRequired
}
